import React from "react";

const CurrentInfoContext = React.createContext({});
export default CurrentInfoContext;
